// import './vConsole.js'

import './init.js';

import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import EthersProvider from './ethers';

import {
  // HashRouter as Router,
  BrowserRouter as Router,
  Route,
  // Link,
  // useHistory
} from "react-router-dom";

import {
  // RouterFlat,
  RouterView
} from './pages/router';
// import { BrowserRouter } from 'react-router-dom';


import useLanguage from './hook/useLanguage'
// config.ts
import { http, createConfig, WagmiProvider } from "wagmi";
import { bsc, mainnet } from "wagmi/chains";
import { injected, safe } from "wagmi/connectors";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import { InjectedConnector } from 'wagmi/connectors/injected';
const queryClient = new QueryClient();

// const projectId = "<WALLETCONNECT_PROJECT_ID>"; // WalletConnect项目ID

// const binanceConnector = new InjectedConnector({
//   chains:[bsc],
//   options: {
//     name: 'Binance Wallet',
//     getProvider: () => (typeof window !== 'undefined' ? window.BinanceChain : undefined),
//   },
// });


const config = createConfig({
  chains: [bsc, mainnet],
  connectors: [
    // binanceConnector,
    injected({
      // chains,
      // shimDisconnect: thund, 
    }),
    // metaMask(),
    safe()
  ],
  transports: {
    [bsc.id]: http(),
    [mainnet.id]: http(),
  },
});



const TEXT_DEFULT_STYLE = {
  color: '#fff',
  fontWeight: 800
}
const theme = createTheme({
  palette: {
    // text: {
    //   primary: TEXT_DEFULT_STYLE.color,
    // },
    background: {
      default: process.env.BACKGROUNDCOLOR,
    }
  },
  typography: {
    // 中文字符和日文字符通常比较大，
    // 所以选用一个略小的 fontsize 会比较合适。
    fontSize: 12,
    subtitle1: TEXT_DEFULT_STYLE,
    body1: TEXT_DEFULT_STYLE,
    button: {
      ...TEXT_DEFULT_STYLE,
      textTransform: 'none'
    }
  },
  components: {
    // Name of the component ⚛️
    MuiDivider: {
      styleOverrides: {
        // Name of the slot
        root: {
          borderColor: 'rgb(248 216 58)'
        },
      },
    },
    
    MuiButton: {
      // defaultProps: {
      //   // The default props to change
      //   // disableRipple: true, // No more ripple, on the whole application 💣!
      //   // sx: {
      //   //   borderRadius: 100,
      //   // },
      // },
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          borderRadius: 100,
          // padding: "4px 12px"
          paddingLeft: '12px',
          paddingRight: '12px'
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: 'transparent',
          boxShadow: 'none',
          minWidth: '90%'
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: '0px 8px',
          // margin: 0,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: process.env.BACKGROUNDCOLOR,
          boxShadow: 'none',
          transition: 'all .3s',
          borderBottom: '0px solid #f2f2f2',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        // Name of the slot
        root: {
          // color: 'red',
          // Some CSS
          borderRadius: '1rem',
        },
      },
    },
  },
});


function App() {
  useLanguage()
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <EthersProvider
            rpc={process.env.RPC}
            chainId={process.env.CHAINID}
          >
            <SnackbarProvider maxSnack={3}>
            {/* <StyledEngineProvider> */}
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <RouterView />
              </ThemeProvider>
            {/* </StyledEngineProvider> */}
            </SnackbarProvider>
          </EthersProvider>
        </Router>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
